<p-popover #sortingOverlay appendTo="body" [styleClass]="'split-view-filter-options-dropdown'">
  <ng-template pTemplate="content">
    @for (s of getSortingOptions(); track s) {
      <div class="option-entry" [ngClass]="{'selected': selectedSortingOption === s.id}" (click)="selectSortingOption(s)">
        @if (selectedSortingOption === s.id) {
          <fa-icon class="icon" [icon]="'check'"></fa-icon>
        }
        @if (selectedSortingOption !== s.id) {
          <span class="icon"></span>
        }
        <span>{{ s.displayName }}</span>
      </div>
    }
  </ng-template>
</p-popover>
<p-popover #filteringOverlay appendTo="body" [styleClass]="'split-view-filter-options-dropdown'">
  <ng-template pTemplate="content">
    @for (f of additionalFilterConfig.filterOptions; track f) {
      <div class="option-entry">
        <p-checkbox [binary]="true" [ngModel]="selectedFilterOptions.includes(f.id)" (ngModelChange)="toggleFilterOption(f.id)"></p-checkbox>
        <span (click)="toggleFilterOption(f.id)">{{ f.displayName }}</span>
      </div>
    }
  </ng-template>
</p-popover>
<div class="filter-container">
  <input pInputText placeholder="Search" [disabled]="disabled" [(ngModel)]="filterString" (ngModelChange)="applyFilter()">
  @if (sortingConfig?.type === 'advanced') {
    <div class="action-icon" [ngClass]="{'disabled': disabled}">
      <fa-icon [icon]="'sort-amount-down'" size="lg" (click)="sortingOverlay.show($event)"></fa-icon>
    </div>
  }
  @if (additionalFilterConfig?.type === 'menu') {
    <div class="action-icon" [ngClass]="{'disabled': disabled}">
      <fa-icon [icon]="'filter'" size="lg" (click)="filteringOverlay.show($event)"></fa-icon>
    </div>
  }
  @if (bulkModeConfig) {
    <div class="toggle-icon" [ngClass]="{'disabled': disabled, 'active': bulkModeState}">
      <fa-icon [icon]="'check-double'" size="lg" (click)="toggleBulkMode()"></fa-icon>
    </div>
  }
  @if (additionalActions) {
    @for (a of additionalActions; track a) {
      <div class="action-icon" [ngClass]="{'disabled': disabled}">
        <fa-icon [icon]="a.icon" size="lg" (click)="a.action()"></fa-icon>
      </div>
    }
  }
</div>
@if (additionalFilterConfig?.type === 'menu' && selectedFilterOptions.length > 0) {
  <div class="filter-pill-container">
    @for (s of selectedFilterOptions; track s) {
      <div class="filter-pill">
        {{ getFilterOptionById(s).displayName }}
        <fa-icon icon="times" size="lg" (click)="toggleFilterOption(s)"></fa-icon>
      </div>
    }
  </div>
}
@if (additionalFilterConfig?.type === 'inline') {
  <div class="filter-inline-container">
    <p-selectButton [disabled]="disabled" class="full-wdith" [options]="additionalFilterConfig.filterOptions" [(ngModel)]="selectedFilterOptions" (onChange)="applyFilter()" [multiple]="true" optionLabel="displayName" optionValue="id"></p-selectButton>
  </div>
}
@if (bulkModeConfig && bulkModeState) {
  <div class="bulk-toggle-container">
    <p-checkbox inputId="selectall" [binary]="true" [ngModel]="false" (ngModelChange)="selectAllClicked($event)"></p-checkbox>
    <label for="selectall">Select all</label>
  </div>
}
